module.exports = __webpack_public_path__ + "img/qui.ceac2ed5.svg";